import { SerializedStyles } from '@emotion/react';

type StyleValue = string | number | ((props: any) => string | number) | SerializedStyles;

export function toggleStyleValue<T>(propName: keyof T, trueValue: StyleValue, falseValue: StyleValue) {
  return (props: T) => (props[propName] ? trueValue : falseValue);
}
